import { ZonedDateTimeFormatter } from '@csp/csp-common-date-util';
import { StudyDocumentsFile } from '@csp/csp-common-file-storage';
import { LabelWidth, ListItemStudyDocument } from '@csp/csp-web-ui';
import { FC } from 'react';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { useDownloadFile } from '../study-documents-file-list/hook/useDownloadFile';
import { StudyDocsUtil } from '../util/StudyDocsUtil';
import { DownloadFileDialog } from '../study-documents-file-list/component/DownloadFileDialog';

type Props = {
  file: StudyDocumentsFile;
  viewUrl: string;
  labelWidth: LabelWidth;
  viewLabel: string;
  versionPublishedLabel: string;
  downloadFileState: ReturnType<typeof useDownloadFile>;
};

export const ViewOrDownloadStudyDocumentListItem: FC<Props> = ({
  file,
  viewUrl,
  versionPublishedLabel,
  viewLabel,
  downloadFileState,
  labelWidth,
}) => {
  const documentsContent = StaticContentService.getGenericBlock('webHcpDocumentRepository', 'documents');
  const fileIsViewable = StudyDocsUtil.fileIsViewable(file);

  return (
    <>
      <ListItemStudyDocument
        title={file.name}
        versionPublishedDate={ZonedDateTimeFormatter.toDisplayDateTimeString(file.createdAt)}
        versionPublishedLabel={versionPublishedLabel}
        linkText={fileIsViewable ? viewLabel : documentsContent.button.download.label}
        labelWidth={labelWidth}
        onClick={(): void => {
          if (fileIsViewable) {
            window.open(viewUrl, '_blank');
          } else {
            downloadFileState.downloadFile({ fileId: file.id, fileName: file.name });
          }
        }}
      />

      <DownloadFileDialog downloadFileState={downloadFileState} />
    </>
  );
};
